import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Tabs, Tab, Table } from "react-bootstrap";
import "./UserProfile.css";
import { useAuth } from "modules/auth/hooks";
import { callApi } from "modules/core/api/services";

import { useUserOrders } from "modules/payment/hooks";
import { useSports } from "modules/sport/hooks";
import { usePlayers } from "modules/players/hooks";
import { useTeams } from "modules/teams/hooks";
import { useCompetitions } from "modules/competitions/hooks";
import { useVenues } from "modules/venues/hooks";
import AccountDetails from "./AccountDetails";
import PersonalPreferences from "./PersonalPreferences";
import { Sport } from "modules/sport/types";
import { Competition } from "types/interfaces/Competition";
import { Team } from "types/interfaces/Team";
import { useClubs } from "modules/clubs/hooks";
import { utcToZonedDate } from "utils/date";
import { TimeZoneContext } from "contexts/TimeZoneContext";

export const UserProfile = () => {
  const [activeTab, setActiveTab] = useState("account-details");
  const [selectSport, setSelectSport] = useState<Sport[]>([]);
  const [selectCompetition, setSelectCompetition] = useState<Competition[]>([]);
  const [selectTeam, setSelectTeam] = useState<Team[]>([]);
  const { sports } = useSports();
  const { userOrders } = useUserOrders();
  const { players } = usePlayers();
  const { teams } = useTeams();
  const { competitions } = useCompetitions();
  const { venues } = useVenues();
  const { clubs } = useClubs();
  const timeZone = useContext(TimeZoneContext);

  const { user } = useAuth();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirm_password: ""
  });

  console.log(user);

  const onSelectSports = (sportUuid: string) => {
    let selectSports = [...selectSport];

    sports.map((sport) => {
      if (sport?.uuid === sportUuid) {
        if (selectSports.includes(sport)) {
          selectSports = selectSports.filter(
            (sport) => sport?.uuid !== sportUuid
          );
        } else {
          selectSports.push(sport);
        }
      }
    });
    setSelectSport(selectSports);
  };

  const onSelectCompetition = (competitionSelect: any) => {
    const selectedCompetitions =
      competitions?.filter(
        (competition) => competition?.uuid === competitionSelect?.target?.value
      ) ?? [];
    console.log(selectedCompetitions);
    setSelectCompetition(selectedCompetitions);
  };

  const onSelectTeam = (teamSelect: any) => {
    const selectedTeams =
      teams?.filter((team) => team?.uuid === teamSelect?.target?.value) ?? [];
    console.log(selectedTeams);
    setSelectTeam(selectedTeams);
  };

  const submitForm = async () => {
    const userData = user?.onboardingData;
    const payload = {
      ...userData,
      firstName: formData.firstName,
      lastName: formData.lastName,
      sports: selectSport,
      competitions: selectCompetition,
      teams: selectTeam
    };

    console.log("payload", payload);

    const userForm = await callApi(`/v2/user`, "PUT", {
      user: {
        onboarded: true,
        onboardingData: {
          ...payload
        }
      }
    });

    // setUser(userForm && userForm.user);
  };

  useEffect(() => {
    setFormData({
      firstName: user?.onboardingData?.firstName ?? "",
      lastName: user?.onboardingData?.lastName ?? "",
      email: user?.email ?? "",
      password: "",
      confirm_password: ""
    });
  }, [user]);

  const handleFieldChange = (fieldName: string, value: string) => {
    setFormData({ ...formData, [fieldName]: value });
  };

  const handleTabSelect = (key: any) => {
    setActiveTab(key);
  };

  return (
    <div style={{ background: "#000", color: "#fff" }} className="user-profile">
      <Container className="container-main" style={{ paddingTop: "100px" }}>
        <Row>
          <Tabs
            id="user-profile-tabs"
            activeKey={activeTab}
            onSelect={handleTabSelect}
            className="mb-6"
          >
            <Tab eventKey="account-details" title="Account details">
              <Row>
                <Col lg={3} xl={2} md={3} style={{ marginBottom: "40px" }}>
                  <img
                    width={"100%"}
                    src="/profilepic.png"
                    alt=""
                    style={{ borderRadius: "10px" }}
                  />
                </Col>
                <Col lg={9} xl={10} md={9} style={{ marginBottom: "90px" }}>
                  <Container>
                    <Row>
                      <Col md={12}>
                        <AccountDetails
                          handleFieldChange={handleFieldChange}
                          formData={formData}
                          user={user && user}
                          submitForm={submitForm}
                        />
                      </Col>
                    </Row>
                  </Container>
                </Col>
              </Row>
            </Tab>

            <Tab eventKey="payment-info" title="Purchases">
              <Row>
                <Col lg={12}>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th style={{ color: "#fff", background: "#000" }}>
                          Type
                        </th>
                        <th style={{ color: "#fff", background: "#000" }}>
                          Subscription
                        </th>
                        <th style={{ color: "#fff", background: "#000" }}>
                          Valid
                        </th>
                        <th style={{ color: "#fff", background: "#000" }}>
                          Status
                        </th>
                        <th style={{ color: "#fff", background: "#000" }}>
                          Price
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {userOrders &&
                        userOrders.map((order, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                color: "#fff",
                                background: "#000",
                                textTransform: "capitalize"
                              }}
                            >
                              {order?.productType.replaceAll("_", " ")}
                            </td>
                            <td style={{ color: "#fff", background: "#000" }}>
                              {order?.productName}
                            </td>
                            <td style={{ color: "#fff", background: "#000" }}>
                              {order?.validUntil &&
                                utcToZonedDate(
                                  order?.validUntil,
                                  timeZone
                                ).toLocaleString()}
                            </td>
                            <td
                              style={{
                                color: "#fff",
                                background: "#000",
                                textTransform: "capitalize"
                              }}
                            >
                              {order?.status}
                            </td>
                            <td style={{ color: "#fff", background: "#000" }}>
                              {order?.priceFormatted}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};
